import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import "./Support.scss";

export const Support = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Preguntas frecuentes
  const faqs = [
    {
      q: "¿Cómo cambio mi contraseña?",
      a: "Ve a tu perfil, ingresa la nueva contraseña y confirma el cambio.",
      icon: "lock",
    },
    {
      q: "¿Cómo actualizo mis datos personales?",
      a: "En tu perfil, puedes editar tus datos personales y guardarlos.",
      icon: "user",
    },
    {
      q: "¿Cómo accedo a mis cursos?",
      a: "En la sección 'Mis Cursos' encontrarás todos los cursos en los que estás inscrito.",
      icon: "book",
    },
    {
      q: "¿Cómo participo en el foro?",
      a: "Ingresa al foro desde el menú y crea un nuevo tema o responde a uno existente.",
      icon: "comments",
    },
    {
      q: "¿Cómo veo mis calificaciones?",
      a: "Puedes ver tus calificaciones en la sección 'Mis Calificaciones'.",
      icon: "star",
    },
    {
      q: "¿Dónde veo mis pagos?",
      a: "En la sección 'Mis Pagos' puedes ver el historial y estado de tus pagos.",
      icon: "dollar sign",
    },
    {
      q: "¿No recibo notificaciones?",
      a: "Verifica que las notificaciones estén activadas en la configuración de tu cuenta, igual puedes ver tus notificaciones en la sección respectiva.",
      icon: "bell",
    },
  ];

  // WhatsApp de soporte (reemplaza el número por el real)
  const whatsappNumber = "51963307082";
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="student-support-page">
      <div className="support-header">
        {/* <Icon name="headphones" size="huge" className="support-header__icon" /> */}
        <h1 className="support-header__title">Centro de Soporte</h1>
        <p className="support-header__description">
          Encuentra respuestas rápidas, contacta a soporte o accede a recursos útiles
          para resolver tus dudas y avanzar en tu experiencia Edunova.
        </p>
      </div>

      <div className="support-content">
        <section className="support-section faq-section">
          <div className="section-header">
            <Icon name="question circle" />
            <h2>Preguntas Frecuentes</h2>
          </div>
          <div className="faq-list">
            {faqs.map((faq, idx) => (
              <div
                className={`faq-item ${activeIndex === idx ? "active" : ""}`}
                key={idx}
              >
                <div
                  className="faq-question"
                  onClick={() => toggleAccordion(idx)}
                >
                  <div className="faq-question__content">
                    <Icon name={faq.icon} className="faq-icon" />
                    <span>{faq.q}</span>
                  </div>
                  <Icon
                    name={activeIndex === idx ? "chevron up" : "chevron down"}
                    className="faq-toggle"
                  />
                </div>
                <div className={`faq-answer ${activeIndex === idx ? "show" : ""}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="support-section contact-section">
          <div className="section-header">
            <Icon name="mail" />
            <h2>Contacto con Soporte</h2>
          </div>
          <div className="contact-cards">
            <a
              href={`mailto:support@edunova.com`}
              className="contact-card"
            >
              <div className="contact-card__icon">
                <Icon name="mail" size="big" />
              </div>
              <div className="contact-card__content">
                <h3>Email</h3>
                <p>support@edunova.com</p>
                <span className="contact-card__action">
                  Enviar mensaje <Icon name="arrow right" />
                </span>
              </div>
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card contact-card--whatsapp"
            >
              <div className="contact-card__icon">
                <Icon name="whatsapp" size="big" />
              </div>
              <div className="contact-card__content">
                <h3>WhatsApp</h3>
                <p>Chat en tiempo real</p>
                <span className="contact-card__action">
                  Abrir chat <Icon name="arrow right" />
                </span>
              </div>
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}
